import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notifications from "react-notification-system-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import styled from "styled-components";

import { handleKey, parseQueryString } from "_helpers";

import breakpoints from "_constants/breakpoints";

import { userActions } from "_store/actions";

import imgBanner from "assets/img/HomeBanner_centeredLogo.jpg";

import { SpinnerWrapper } from "widget/Spinner";
import Brand from "widget/Brand";

const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: url(${imgBanner}) no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 624px;

  @media (max-height: 624px) {
    min-height: 0;
  }
`;
const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Header = styled.div`
  padding: 15px 15px 0;
  display: flex;
  justify-content: center;
`;
const Content = styled.div`
  padding: 15px 15px 10px;
  font-size: 22px;
  line-height: 30px;

  .login-message {
    font-size: 18px;
    text-align: center;
  }

  @media (max-width: ${breakpoints.mobileS}) {
    font-size: 12px;
    line-height: 14px;

    .form-control {
      font-size: 12px;
    }
  }
`;
const Group = styled(Form.Group)`
  margin-bottom: 1rem;
`;
const StyledButton = styled(Button)`
  font-size: 1em;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ButtonLink = styled.button`
  border: none;
  background: none;
  color: #0d6efd;
  text-decoration: underline;
`;

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();
  const { token } = parseQueryString(search);

  const { loading, error } = useSelector(({ user }) => user);
  const { notifications } = useSelector((store) => store);

  const [user, setUser] = useState({ email: "", password: "" });
  const [hasNotification, setHasNotification] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    if (error) {
      dispatch(userActions.loginResetError());
    }

    setUser({ ...user, [name]: value });
  };

  const handleKeyPress = (e) => {
    if (handleKey(e)) {
      handleSubmit(e);
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { email, password } = user;
    if (email && password) {
      dispatch(userActions.login(email, password, "TRADEMARKS"));
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(userActions.loginByToken(token));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (!hasNotification && notifications.length > 0) {
      setHasNotification(true);
    } else {
      setHasNotification(false);
    }
  }, []);

  return (
    <>
      <Layout>
        <Container fluid>
          <Row className="justify-content-center mt-5">
            <Col xs={10} md={6} lg={4}>
              <div className="card">
                <Header>
                  <Brand />
                </Header>
                <Content>
                  {!token && (
                    <StyledForm onSubmit={handleSubmit} onKeyPress={handleKeyPress}>
                      <Group controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Email"
                          name="email"
                          value={user.email}
                          onChange={handleChange}
                          isInvalid={error}
                        />
                      </Group>

                      <Group controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          name="password"
                          value={user.password}
                          onChange={handleChange}
                          isInvalid={error}
                        />
                        <Form.Control.Feedback type="invalid">Incorrect email or password</Form.Control.Feedback>
                      </Group>
                      <Buttons>
                        <ButtonLink type="button" onClick={() => navigate("/forgot-password")}>
                          Forgot your password?
                        </ButtonLink>
                        <StyledButton variant="primary" type="submit">
                          Login
                        </StyledButton>
                      </Buttons>
                    </StyledForm>
                  )}
                  {token && (
                    <div className="login-message">
                      <span>Authorization...</span>
                    </div>
                  )}
                </Content>
              </div>
            </Col>
          </Row>
        </Container>
      </Layout>
      {loading && <SpinnerWrapper />}

      <Notifications notifications={notifications} />
    </>
  );
}
